const AppConstants = {
  ALIGN_BOTTOM: "bottom",
  ALIGN_CENTER: "center", // y
  ALIGN_LEFT: "left",
  ALIGN_MIDDLE: "middle", // x
  ALIGN_RIGHT: "right",
  ALIGN_TOP: "top",
  ALLOWED_BG_IMAGE_EXTS: ["png", "jpeg", "jpg"],

  ANIMATION_DIRECTION_NONE: "none",
  ANIMATION_DIRECTION_RIGHT: "Right",
  ANIMATION_DIRECTION_LEFT: "Left",
  ANIMATION_DIRECTION_UP: "Up",
  ANIMATION_DIRECTION_DOWN: "Down",
  ANIMATION_DIRECTION_DOWN_RIGHT: "DownRight",
  ANIMATION_DIRECTION_DOWN_LEFT: "DownLeft",
  ANIMATION_DIRECTION_UP_RIGHT: "UpRight",
  ANIMATION_DIRECTION_UP_LEFT: "UpLeft",
  ANIMATION_DIRECTION_X: "X",
  ANIMATION_DIRECTION_Y: "Y",

  ANIMATION_TYPE_NONE: "none",
  ANIMATION_TYPE_FADE: "fade",
  ANIMATION_TYPE_SLIDE: "slide",
  ANIMATION_TYPE_BOUNCE: "bounce",
  ANIMATION_TYPE_ROTATE: "rotate",
  ANIMATION_TYPE_ZOOM: "zoom",
  ANIMATION_TYPE_FLIP: "flip",
  ANIMATION_TYPE_ROLL: "roll",
  ANIMATION_TYPE_LIGHT_SPEED: "lightSpeed",
  ANIMATION_TYPE_PAGE: "page",
  ANIMATION_TYPE_BLOCK: "block",

  ASSET_LIBRARY_MODE_VIEW: "view",
  ASSET_LIBRARY_MODE_MANAGE: "manage",
  ASSET_LIBRARY_MODE_CHOOSER: "chooser",
  ASSET_LIBRARY_MODE_GALLERY_CHOOSER: "galleryChooser",
  ASSET_LIBRARY_TAB_FILES: "files",
  ASSET_LIBRARY_TAB_STOCK: "stock",

  ASSET_TYPE_IMAGE: 1,
  ASSET_TYPE_VIDEO: 2,
  ASSET_TYPE_AUDIO: 3,
  ASSET_TYPE_LOTTIE: 5,
  ASSET_TYPE_FILE: 9,

  ASSET_TYPE_IMAGE_EXTS: ["png", "jpeg", "jpg", "gif", "svg"],
  ASSET_TYPE_VIDEO_EXTS: ["mp4", "mpeg4"],
  ASSET_TYPE_AUDIO_EXTS: ["mp3"],
  ASSET_TYPE_LOTTIE_EXTS: ["lottie"],

  ASSET_IMAGE_ONLY_EXTS: ["png", "jpeg", "jpg", "gif"],

  ASSET_STATUS_PENDING: 0,
  ASSET_STATUS_ACTIVE: 1,
  ASSET_STATUS_UNAVAILABLE: 2,

  ASSET_WIDTHS: [200, 400, 800, 1200, 1600, 2400, 3200],

  BG_PROPERTY_ASSET_KEY: "key",
  BG_PROPERTY_BG_COLOR: "bgColor",
  BG_PROPERTY_FILL_TYPE: "bgFillType",
  BG_PROPERTY_LOOP: "bgLoop",
  BG_PROPERTY_POSITION: "bgPos",
  BG_PROPERTY_OPACITY: "bgOpacity",
  BG_PROPERTY_SCALE: "bgScale",
  BG_PROPERTY_SCROLL: "bgScroll",
  BG_PROPERTY_IMAGE: "bgImage",
  BG_PROPERTY_VIDEO: "bgVideo",
  BG_PROPERTY_GRADIENT_ROTATION: "bgGr",
  BG_PROPERTY_GRADIENT_COLOR_1: "bgGc1",
  BG_PROPERTY_GRADIENT_COLOR_2: "bgGc2",
  BG_PROPERTY_LOOP_PLAY_ONCE: "0",
  BG_PROPERTY_LOOP_REPEAT: "1",
  BG_PROPERTY_MEDIA_TYPE: "bgMediaType",
  BG_PROPERTY_POSITION_MIDDLE_CENTER: "cm",
  BG_PROPERTY_POSITION_TOP_LEFT: "lt",
  BG_PROPERTY_POSITION_TOP_CENTER: "ct",
  BG_PROPERTY_POSITION_TOP_RIGHT: "rt",
  BG_PROPERTY_POSITION_MIDDLE_LEFT: "lm",
  BG_PROPERTY_POSITION_MIDDLE_RIGHT: "rm",
  BG_PROPERTY_POSITION_BOTTOM_LEFT: "lb",
  BG_PROPERTY_POSITION_BOTTOM_CENTER: "cb",
  BG_PROPERTY_POSITION_BOTTOM_RIGHT: "rb",

  BG_PROPERTY_REPEAT: "repeat",
  BG_PROPERTY_REPEAT_NONE: "none",
  BG_PROPERTY_SCALE_COVER: "cover",
  BG_PROPERTY_SCALE_FIT: "fit",
  BG_PROPERTY_SCALE_NATIVE: "native",
  BG_PROPERTY_SCROLL_W_PAGE: "p",
  BG_PROPERTY_SCROLL_PARALLAX: "x",
  BG_PROPERTY_SCROLL_FIXED: "f",
  BG_PROPERTY_TYPE: "type",
  BG_PROPERTY_UNDERLAY_TYPE: "underlayType",
  BG_TYPE_NONE: "none",
  BG_TYPE_COLOR: "color",
  BG_TYPE_GRADIENT: "gradient",
  BG_TYPE_IMAGE: "image",
  BG_TYPE_VIDEO: "video",
  BG_TYPE_WP_FEATURED_IMAGE: "wpFeaturedImage",

  BLACK: "#000000",

  BUTTON_STATE_REGULAR: "regular",
  BUTTON_STATE_HOVER: "hover",

  DEFAULT_PALETTE: [
    "#000000",
    "#222222",
    "#444444",
    "#666666",
    "#888888",
    "#aaaaaa",
    "#cccccc",
    "#ffffff",
  ],

  THEME_STYLES: "styles",
  THEME_BG_PROPERTY_COLOR: "bgcolor",
  THEME_BG_PROPERTY_LINK: "link",

  BLOG_TYPE_NONE: "NONE",
  BLOG_TYPE_BASIC: "BASIC",
  BLOG_TYPE_ADVANCED: "ADV",

  BLOG_STATUS_PROCESSING: 1,
  BLOG_STATUS_AWAITING: 2,
  BLOG_STATUS_AVAILABLE: 5,

  // minimum supported version: 113

  // supported browsers and min version
  BROWSERS: {
    chrome: 88,
    safari: 17,
  },

  BUTTON_TAG_NAME: "SI-BUTTON",

  CUSTOM_TAG_DISABLED: "customTagDisabled",

  // The number of places to the right of the decimal
  DECIMAL_PRECISION: 0,

  DEFAULT_AUTO_ADVANCE_TIME: "3",
  DEFAULT_GALLERY_TRANSITION: "fade",
  DEFAULT_GALLERY_TRANSITION_TIME: "0.5",

  DEFAULT_SIMPLE_COLOR: "colors-0",
  DEFAULT_ICON_COLOR: "colors-2",

  DEFAULT_LINE_PROPERTIES: {
    lineStyle: "solid",
    lineCap: "butt",
    h: 3,
    c: "colors-0",
    dW: 21,
    dF: 15,
  },

  DROP_BORDER: "solid 2px white",
  DROP_IN_BORDER: "solid var(--stroke-border-heavy) var(--background-accent-primary)",
  DROP_SHADOW_TOP: "0 .3rem .3rem -.15rem inset var(--background-accent-primary)",
  DROP_SHADOW_BOTTOM: "0 -.3rem .3rem -.15rem inset var(--background-accent-primary)",
  DROP_SHADOW_CENTER: "0 0 .3rem .15rem var(--background-accent-primary) inset",
  DROP_CONTAINER_BACKGROUND:
    "color-mix(in srgb, var(--background-hover-button-accent) 20%, transparent)",

  DEFAULT_DROP_SHADOW_PROPERTIES: {
    style: "none",
    sc: "#000000:50",
    sx: 2,
    sy: 2,
    sb: 5,
  },

  DEFAULT_OPACITY: 100,
  DESELECT_PALETTE: -1,

  DEFAULT_SOCIAL_GRID_PROPERTIES: {},

  BORDER_CIRCLE_RAD: "50%",
  BORDER_WIDTH_DEFAULT: 0,

  DEFAULT_BORDER_PROPERTIES: {
    width: 4,
    color: "colors-0",
  },

  CANVAS_SET_BLOCK_CONTENT_SEPARATOR: "page_content",
  CANVAS_SET_LAYER_PANEL_CANVAS_SET: "canvasSet",
  CANVAS_SET_LAYER_PANEL_PAGE: "page",
  CANVAS_SET_CHILDREN: "children",
  CANVAS_SET_DATA: "canvasSetData",
  CANVAS_SET_DEFAULT: "default",

  CORNER_STYLE_LABEL: "Corners",
  CORNER_STYLE_OPTION_ELLIPSE: "ellipse",
  CORNER_STYLE_OPTION_NONE: "sharp",
  CORNER_STYLE_OPTION_ROUND: "round",
  CORNER_INDEX: {
    TL: 0,
    TR: 1,
    BR: 2,
    BL: 3,
  },
  CORNER_PRESET_LABEL_CURVED_SIDE: "Curved side",
  CORNER_PRESET_LABEL_SHARP_CORNER: "Sharp corner",
  CORNER_PRESET_LABEL_OPPOSITE_CORNER: "Opposite",
  CORNER_PRESET_LABEL_CURVED_CORNER: "Curved corner",

  BLOCK_ACTION_SHOW: "show",
  BLOCK_ACTION_HIDE: "hide",
  BLOCK_ACTION_CHANGE: "change",

  BLOCK_TRIGGER_ON_SCREEN: "onscreen",
  BLOCK_TRIGGER_OFF_SCREEN: "offscreen",
  BLOCK_TRIGGER_PERCENT_SCREEN: "percent",

  BLOCK_PROP_PARENT_BLOCK_ID: "pBlockId",
  BLOCK_PROP_PARENT_BLOCK: "pBlock", // only used to builder
  BLOCK_PROP_SELECTED: "selected",
  BLOCK_PROP_SELECTED_LAYOUT_PATH: ["selected", "layout"],

  BLOCK_NAME: "name",
  BLOCK_ID: "id",
  BLOCK_SLUG: "slug",
  BLOCK_TYPE: "type",
  BLOCK_WP: "wp",

  SUPPORTED_BROWSERS_HELP_DOC_URL:
    "https://learn.showit.com/en/articles/2694424-how-can-i-try-showit#h_2d0dcbcd42",
  CHROME_UPDATE_HELP_URL: "https://support.google.com/chrome/answer/95414",
  CONTEXT_ITEM_BUTTON: "context-item-btn",

  DESIGN_ITEM_PROP_ID: "id",
  DESIGN_ITEM_PROP_NAME: "name",
  DESIGN_ITEM_PROP_PARENT_TYPE: "pType",
  DESIGN_ITEM_PROP_VISIBLE: "visible",

  DESIGN_TYPE_BLOCK: "B",
  DESIGN_TYPE_PAGE: "P",
  DESIGN_TYPE_SITE: "S",
  DESIGN_TYPE_WP_BLOCK: "WB",
  DESIGN_TYPE_WP_PAGE: "WP",
  DESIGN_TYPE_SITE_BLOCK: "SB",

  DISABLED_DIVIDER: "----------------",
  DISTRIBUTE_BOTTOM: "bottom",
  DISTRIBUTE_CENTER: "center", // y
  DISTRIBUTE_LEFT: "left",
  DISTRIBUTE_MIDDLE: "middle", // x
  DISTRIBUTE_RIGHT: "right",
  DISTRIBUTE_TOP: "top",
  DISTRIBUTE_HORIZONTAL_SPACE: "x",
  DISTRIBUTE_VERTICAL_SPACE: "y",

  ELEMENT_TYPE_ALL: "all",
  ELEMENT_TYPE_GRAPHIC: "graphic",
  ELEMENT_TYPE_SIMPLE: "simple",
  ELEMENT_TYPE_OVAL: "oval",
  ELEMENT_TYPE_LINE: "line",
  ELEMENT_TYPE_STATES: "states",
  ELEMENT_TYPE_SVG: "svg",
  ELEMENT_TYPE_TEXT: "text",
  ELEMENT_TYPE_HTML_TEXT: "html",
  ELEMENT_TYPE_VIDEO: "video",
  ELEMENT_TYPE_GALLERY: "gallery",
  ELEMENT_TYPE_ICON: "icon",
  ELEMENT_TYPE_IFRAME: "iframe",
  ELEMENT_TYPE_SOCIAL_GRID: "social",
  ELEMENT_TYPE_BUTTON: "button",
  ELEMENT_TYPE_FORM_INPUT: "input",
  ELEMENT_TYPE_FORM_SELECT: "select",
  ELEMENT_TYPE_FORM_RADIO: "radio",
  ELEMENT_TYPE_FORM_CHECKBOX: "checkbox",
  ELEMENT_TYPE_GROUP: "group",
  ELEMENT_TYPE_LOTTIE: "lottie",

  INPUT_SOURCE_PROPERTY_INPUT: "propertyInput",
  INPUT_BASE_CLASS: "si-c-property-input",

  SOCIAL_GRID_TYPE_INSTAGRAM: "instagram",

  ELEMENT_ACTION_SHOW: "show",
  ELEMENT_ACTION_HIDE: "hide",
  ELEMENT_ACTION_SHOW_SITE_BLOCK: "show-sb",
  ELEMENT_ACTION_HIDE_SITE_BLOCK: "hide-sb",
  ELEMENT_ACTION_MESSAGE: "message",
  ELEMENT_ACTION_GALLERY: "gallery",

  ELEMENT_GALLERY_TYPE_SIMPLE: "simple",
  ELEMENT_GALLERY_TYPE_TILE: "tile",
  ELEMENT_GALLERY_TYPE_SLIDING: "sliding",

  GALLERY_TRANSITION_FADE: "fade",
  GALLERY_TRANSITION_SLIDE: "scrollHorz",
  GALLERY_TRANSITION_NONE: "none",

  GALLERY_ACTION_PLAY: "play",
  GALLERY_ACTION_PAUSE: "pause",
  GALLERY_ACTION_TOGGLE: "toggle",
  GALLERY_ACTION_NEXT: "next",
  GALLERY_ACTION_PREVIOUS: "prev",
  GALLERY_ACTION_GOTO: "goto",

  GALLERY_VIEW_TYPE_LIST_SMALL: "list-small",
  GALLERY_VIEW_TYPE_LIST_LARGE: "list-large",

  MAX_DESIGNS_FOR_TRIAL_ERROR_MESSAGE: "Only 3 designs allowed when not subscribed",
  EXPRESSIONS_SUCCESS: [
    "Shazam",
    "Woot",
    "Hot dog",
    "Hot Diggity",
    "Whizz-Bang",
    "Oooh Dude",
    "Whoop-Whoop",
    "Whaaaaat?",
    "Swell",
    "It Worked",
    "Yay Internet",
    "Splendid",
    "Lovely",
    "Oh Boy",
  ],

  EXPRESSIONS_ERROR: [
    "Aw Snap",
    "Fiddlesticks",
    "Criminy",
    "Curses",
    "Houston, we have a problem",
    "Doh",
  ],

  EXPRESSIONS_VISIT: ["Dig it", "Check it out"],

  GRAPHIC_SCALE_FILL: "cover",
  GRAPHIC_SCALE_CONTAIN: "fit",
  GRAPHIC_SCALE_STRETCH: "stretch",
  GRAPHIC_SCALE_ZOOM: "zoom",

  EXT_GIF: "gif",
  EXT_HEIC: "heic",
  EXT_LOTTIE: "lottie",
  EXT_JSON: "json",
  EXT_MOV: "mov",
  EXT_MP4: "mp4",
  EXT_SVG: "svg",
  EXT_WOFF: "woff",
  EXT_WOFF2: "woff2",

  GOOGLE_FONT_VARIANTS: {
    regular: { display: "Normal" },
    italic: { display: "Italic" },
    100: { display: "Thin" },
    "100italic": { display: "Thin Italic" },
    200: { display: "Ultra Light" },
    "200italic": { display: "Ultra Light Italic" },
    300: { display: "Light" },
    "300italic": { display: "Light Italic" },
    500: { display: "Medium" },
    "500italic": { display: "Medium Italic" },
    600: { display: "Semi Bold" },
    "600italic": { display: "Semi Bold Italic" },
    700: { display: "Bold" },
    "700italic": { display: "Bold Italic" },
    800: { display: "Ultra Bold" },
    "800italic": { display: "Ultra Bold Italic" },
    900: { display: "Heavy" },
    "900italic": { display: "Heavy Italic" },
  },

  HOVER_TYPE_NONE: "none",
  HOVER_TYPE_CUSTOM: "custom",
  HOVER_TYPE_PAGE: "page",
  HOVER_TYPE_BLOCK: "block",

  ICON_MAX_LENGTH: 3500, // 3500 max length of svg allowed for icon

  ID_LENGTH: 9,

  IMPORT_DESIGN_INITIAL: "init",
  IMPORT_DESIGN_LOADING: "loading",
  IMPORT_DESIGN_COMPLETED: "completed",

  // types of items that are part of a design
  ITEM_TYPE_BLOCK: "block",
  ITEM_TYPE_CANVAS_SET: "canvasSet",
  ITEM_TYPE_CANVAS_SET_BLOCK: "canvasSetBlock",
  ITEM_TYPE_ELEMENT: "element",
  ITEM_TYPE_GROUP: "group",
  ITEM_TYPE_PAGE: "page",
  ITEM_TYPE_SITE_ITEMS: "items",
  ITEM_TYPE_STATE: "state",
  ITEM_TYPE_SITE_BLOCK: "site-block", // only used in app for decision making
  ITEM_TYPE_PAGE_FOLDER: "folder",

  LAYOUT_MOBILE: "mobile",
  LAYOUT_DESKTOP: "desktop",
  SYNCED_PROPS: "sync",
  SYNCED_PROPS_PLACEHOLDER: "placeholder",

  LAYOUT_MOBILE_WIDTH: 320,
  LAYOUT_DESKTOP_WIDTH: 1200,

  LIBRARY_TYPE_SHOWIT: "showit",
  LIBRARY_TYPE_USER: "user",

  LIBRARY_VIEW_INITIAL: "initial",
  LIBRARY_VIEW_PREVIEW: "preview",
  LIBRARY_VIEW_CREATING: "creating",
  LIBRARY_VIEW_ERROR: "error",

  LINK_TYPE_NONE: "none",
  LINK_TYPE_PAGE: "page",
  LINK_TYPE_BLOCK: "block",
  LINK_TYPE_URL: "url",
  LINK_TYPE_SOCIAL: "socialLink", // "social" was already taken
  LINK_TYPE_SHARE: "social", // "social" value cannot be changed
  LINK_TYPE_SMS: "sms",
  LINK_TYPE_PHONE: "phone",
  LINK_TYPE_EMAIL: "email",
  LINK_TYPE_WP_POST: "wp_post",
  LINK_TYPE_PAGE_TOP: "top",

  LINK_SOCIAL_FACEBOOK: "fb",
  LINK_SOCIAL_PINTEREST: "pin",
  LINK_SOCIAL_TWITTER: "twitter",
  LINK_SOCIAL_LINKED_IN: "linkedin",
  LINK_SOCIAL_EMAIL: "email",

  LINK_STATE_NEXT: "next",
  LINK_STATE_PREVIOUS: "prev",

  LOCAL_STORE_DEBUG_JSON_KEY: "siDebugJSON",
  LOCAL_STORE_BROWSER_OVERRIDE: "siBrowserOverride",
  LOCAL_STORE_DEV_TOOLS: "siDevTools",

  LOCK_EDITING_KEY: "lockEditing",
  LOCK_ICON_CIRCLE_SIZE: 10,
  LOCK_ICON_OFFSETS: {
    x: -4.5,
    y: 4,
    w: -5.5,
    h: -3,
  },

  MAIN_VIEW_DESIGN: "design",
  MAIN_VIEW_ERROR: "error",
  MAIN_VIEW_LOADING: "loading",
  MAIN_VIEW_LIBRARY_SITE_CHOOSER: "librarySiteChooser",
  MAIN_VIEW_LIBRARY_SITE_PREVIEW: "librarySitePreview",
  MAIN_VIEW_LOGIN: "login",
  MAIN_VIEW_BROWSER: "browser",
  MAIN_VIEW_BROWSER_UPDATE: "browserUpdate",
  MAIN_VIEW_OFFLINE: "offline",
  MAIN_VIEW_USER_SITE_CHOOSER: "userSiteChooser",
  MAIN_VIEW_SUBSCRIBE: "subscribe",

  MATCH_SIZE_WIDTH: "w",
  MATCH_SIZE_HEIGHT: "h",
  MATCH_SIZE_BOTH: "b",

  MAX_SIZE_VIDEO: 8598323, // bytes roughly 8.2MB
  MAX_SIZE_FILE: 21076377, // bytes roughly 20MB
  MAX_SIZE_LOTTIE: 2097152, // bytes, 2MB
  MAX_SIZE_SVG: 3200000,
  MAX_ELEMENT_WIDTH: 1000000,
  MAX_ELEMENT_HEIGHT: 1000000,

  TOAST_SUCCESS: "success",
  TOAST_ERROR: "error",
  TOAST_WARNING: "warning",

  MODAL_STATE_OPEN: 1,
  MODAL_STATE_CLOSED: 2,
  MODAL_STATE_INACTIVE: 3,

  // should match properties withing modals in DesignViewStore
  MODAL_ACTION_CONFIRM: "actionConfirm",
  MODAL_ASSET_LIBRARY: "assetLibrary",
  MODAL_USER_BLOGS: "userBlogs",
  MODAL_USER_EXPORTS: "userExports",
  MODAL_DESIGN_CHOOSER: "designChooser",
  MODAL_DESIGN_EXPORT: "designExport",
  MODAL_DESIGN_IMPORT: "designImport",
  MODAL_DESIGN_PREVIEW: "designPreview",
  MODAL_DESIGN_PUBLISH: "designPublish",
  MODAL_BLOG_SETUP: "blogSetup",
  MODAL_DOMAIN_MANAGER: "domainManager",
  MODAL_DOMAIN_SETUP: "domainSetup",
  MODAL_DOMAIN_SETTINGS: "domainSettings",
  MODAL_SITE_SETTINGS: "siteSettings",
  MODAL_SIGNUP: "signup",
  MODAL_LAYOUT_CHOOSER: "layoutChooser",
  MODAL_ADMIN_RESTORE: "adminRestore",
  MODAL_RENDERER_LOCK_IN: "rendererLockIn",

  MAX_HEIGHT_100: "100%",
  MIN_OPACITY: 0,
  MAX_OPACITY: 100,
  MAX_WIDTH_100: "100%",

  PAGE_BLOCKS: "blocks",
  PAGE_DATA: "data",
  PAGE_ID: "id",
  PAGE_NAME: "name",
  PAGE_SLUG: "slug",
  PAGE_WP: "wp",

  PANEL_BLOCKS: "blocks",
  PANEL_EXPORT: "export",
  PANEL_THEME: "theme",
  PANEL_WORDPRESS: "wordpress",
  PANEL_LAYERS: "elements",
  PANEL_PAGES: "pages",
  PANEL_SITES: "sites",
  PANEL_PUBLISH: "publish",

  PANEL_PROPERTIES_PAGE: "page",
  PANEL_PROPERTIES_BLOCK: "block",
  PANEL_PROPERTIES_ELEMENT: "element",
  PANEL_PROPERTIES_STATE: "state",

  PANEL_SECTION_PAGE_INFO: "pageInfo",
  PANEL_SECTION_PAGE_BG: "pageBG",
  PANEL_SECTION_PAGE_BLOCK_DEPTH: "pageBlockDepth",
  PANEL_SECTION_PAGE_ANIMATION: "pageAnimation",
  PANEL_SECTION_PAGE_SEO: "pageSEO",
  PANEL_SECTION_PAGE_ADVANCED: "pageAdvanced",

  PANEL_SECTION_BLOCK_INFO: "blockInfo",
  PANEL_SECTION_BLOCK_SIZE: "blockSize",
  PANEL_SECTION_BLOCK_BG: "blockBG",
  PANEL_SECTION_BLOCK_ANIMATION: "blockAnimation",
  PANEL_SECTION_BLOCK_STATE_ANIMATION: "blockStateAnimation",
  PANEL_SECTION_BLOCK_ACTIONS: "blockActions",
  PANEL_SECTION_BLOCK_STATE: "blockState",
  PANEL_SECTION_BLOCK_ADVANCED: "blockAdvanced",

  PANEL_SECTION_STATE_INFO: "stateInfo",
  PANEL_SECTION_STATE_BG: "stateBG",
  PANEL_SECTION_STATE_ANIMATION: "stateAnimation",

  PANEL_SECTION_ELEMENT_SIZE: "elementSize",
  PANEL_SECTION_ELEMENT_ACTIONS: "elementActions",
  PANEL_SECTION_ELEMENT_ANIMATION: "elementAnimation",
  PANEL_SECTION_ELEMENT_CLICK: "elementClick",
  PANEL_SECTION_ELEMENT_HOVER: "elementHover",
  PANEL_SECTION_ELEMENT_LOCKING: "elementLocking",
  PANEL_SECTION_ELEMENT_EFFECTS: "elementEffects",
  PANEL_SECTION_ELEMENT_GRAPHIC: "elementGraphic",
  PANEL_SECTION_ELEMENT_SVG: "elementSVG",
  PANEL_SECTION_ELEMENT_ICON: "elementIcon",
  PANEL_SECTION_ELEMENT_ICON_CHOOSER: "elementIconChooser",
  PANEL_SECTION_ELEMENT_TEXT: "elementText",
  PANEL_SECTION_ELEMENT_LINE: "elementLine",
  PANEL_SECTION_ELEMENT_BUTTON: "elementButton",
  PANEL_SECTION_ELEMENT_SIMPLE: "elementSimple",
  PANEL_SECTION_ELEMENT_TEXT_FORM: "elementTextForm",
  PANEL_SECTION_ELEMENT_TEXT_PROPERTIES: "elementTextProperties",
  PANEL_SECTION_ELEMENT_VIDEO: "elementVideo",
  PANEL_SECTION_ELEMENT_GALLERY: "elementGallery",
  PANEL_SECTION_ELEMENT_GALLERY_IMAGES: "elementGalleryImages",
  PANEL_SECTION_ELEMENT_IFRAME: "elementIFrame",
  PANEL_SECTION_ELEMENT_SOCIAL_GRID: "elementSocialGrid",
  PANEL_SECTION_ELEMENT_FALLBACK_IMAGES: "elementFallbackImages",
  PANEL_SECTION_ELEMENT_LOTTIE: "elementLottie",
  PANEL_SECTION_ELEMENT_FORM_FIELD: "elementFormField",
  PANEL_SECTION_ELEMENT_CLASSNAME: "layer-label",

  PANEL_SECTION_ELEMENTS_ALIGN: "elementsAlign",

  PANEL_WIDTH_CLOSED: ".9375rem",
  PANEL_WIDTH_OPEN: "15.9375rem",

  PARSE_INT_DEFAULT_RADIX: 10,

  PROPERTY_BACKGROUND: "background",

  PROPS_VIEW_ELEMENT: "propsElement",
  PROPS_VIEW_MULTI_ELEMENT: "propsMultiElement",
  PROPS_VIEW_BLOCK: "propsBlock",
  PROPS_VIEW_PAGE: "propsPage",
  PROPS_VIEW_BLOCK_PAGE: "propsBlockPage",

  PREVIEW_VIEW_SAVING: "saving",
  PREVIEW_VIEW_PROCESSING: "processing",
  PREVIEW_VIEW_COMPLETE: "complete",
  PREVIEW_VIEW_ERROR: "error",

  PUBLISH_VIEW_INITIAL: "initial",
  PUBLISH_VIEW_SAVING: "saving",
  PUBLISH_VIEW_PUBLISHING: "publishing",
  PUBLISH_VIEW_PUBLISH_BLOG: "publish_blog",
  PUBLISH_VIEW_COMPLETE: "complete",
  PUBLISH_VIEW_ERROR: "error",
  PUBLISH_VIEW_ERROR_BLOG: "error_blog",
  PUBLISH_VIEW_SUBSCRIBE: "subscribe",

  /** Site renderer version that routes publish/export/preview to the protorenderer endpoints */
  RENDERER_V2: 2,

  RESOURCE_ASSET: "asset",
  RESOURCE_BLOCK: "block",

  SELECT_INITIATOR_STAGE: "stage",
  SELECT_INITIATOR_PANEL: "panel",

  SELECT_EMPTY_OPTION_TEXT: "-- Select --",

  SHOWIT_STORE_SUBSCRIBE: "subscribe",
  SHOWIT_STORE_SUBSCRIPTION: "subscription",

  SITE_ITEM_SITE: "site",
  SITE_ITEM_BLOCK: "block",
  SITE_ITEM_CANVAS_SET: "canvasSet",
  SITE_ITEM_PAGE: "page",
  SITE_ITEM_WP_PAGE: "wppage",
  SITE_ITEM_FOLDER: "folder",

  STAGE_MOBILE_SPLIT_WIDTH: 400,
  STAGE_PADDING: 64,

  STAGE_TOP_BOTTOM_PADDING: 64 * 2,

  STAGE_VIEW_MOBILE: "mobile",
  STAGE_VIEW_DESKTOP: "desktop",
  STAGE_VIEW_SPLIT: "split",


  STAGE_OVERLAY_MOBILE: "mobile",
  STAGE_OVERLAY_GUIDES: "guides",
  STAGE_OVERLAY_COLUMN_GUIDES: "columnGuides",
  STAGE_OVERLAY_CENTER_GUIDES: "centerGuides",
  STAGE_ENABLE_SNAPPING: "enableSnapping",

  SUBSCRIPTION_SERVICE_CHARGEBEE: "cb",
  SUBSCRIPTION_SERVICE_EDD: "edd",

  TEXT_OVERFLOW_DISPLAY: "",
  TEXT_OVERFLOW_SINGLE_LINE: "s",
  TEXT_OVERFLOW_SINGLE_LINE_ELLIPSIS: "se",
  TEXT_OVERFLOW_CROP: "t",

  TEXT_LETTER_CASE_UPPERCASE: "uppercase",
  TEXT_LETTER_CASE_LOWERCASE: "lowercase",
  TEXT_LETTER_CASE_CAPITALIZE: "capitalize",

  TEXT_STYLE_TITLE: "title",
  TEXT_STYLE_HEADING: "heading",
  TEXT_STYLE_SUBHEADING: "subheading",
  TEXT_STYLE_PARAGRAPH: "paragraph",

  TEXT_STYLE_BUTTON_PRIMARY: "buttonPrimary",
  TEXT_STYLE_BUTTON_SECONDARY: "buttonSecondary",

  BUTTON_STYLE_PRIMARY: "primary",
  BUTTON_STYLE_SECONDARY: "secondary",

  BUTTON_TEXT_STYLE_PRIMARY: "buttonPrimary",
  BUTTON_TEXT_STYLE_SECONDARY: "buttonSecondary",

  BUTTON_UI_STATE_PRIMARY_TAB: "primaryTabState",
  BUTTON_UI_STATE_SECONDARY_TAB: "secondaryTabState",
  BUTTON_UI_STATE_SELECTED_PANEL: "selectedPanel",

  TEXT_TRANSFORM_UNSET_VALUE: "none",

  THEME_TAB_STYLE: "style",
  THEME_TAB_FONTS: "fonts",
  THEME_TAB_BUTTONS: "buttons",
  THEME_TAB_BRAND_COLORS: "brandColors",
  THEME_TAB_FORM_FIELDS: "formFields",

  TOUR_MAX_ACCOUNT_AGE: 7,

  TRANSPARENT: "#000000:0",
  TYPE_STYLES_HEADER_HEIGHT: "typeStylesHeaderHeight",

  SITE_KEY: "userSite",
  SITE_INIT_PAGE_KEY: "initPageId",
  TOKEN_KEY: "authToken",
  PREFERENCES_KEY: "siPreferences",
  TUTORIAL_VIDEO_SEEN_KEY: "siTutorialVideoSeen",
  // Max account age (in days) for a user to be considered "new" and auto-shown the tutorial video.
  TUTORIAL_VIDEO_MAX_ACCOUNT_AGE: 7,
  // key to signal adding a design to an account with none
  INIT_DESIGN: "initDesign",

  UNSUPPORTED_EXTS: ["mov", "heic"],
  UPLOAD_STATUS_PENDING: 0,
  UPLOAD_STATUS_IN_PROGRESS: 1,
  UPLOAD_STATUS_ERROR: 9,

  UPDATE_ACTION_SET: "set",
  UPDATE_ACTION_DELETE: "delete",
  UPDATE_ACTION_MERGE: "merge",

  USER_SITES_VIEW_LIST: "list",
  USER_SITES_VIEW_OPENING: "opening",
  USER_SITES_VIEW_CREATING: "creating",
  USER_SITES_VIEW_ERROR: "error",

  USER_SITES_VIEW_MODE_SELECT: "select",
  USER_SITES_VIEW_MODE_MANAGE: "manage",

  USER_STATUS_ACTIVE: "ACTIVE",
  USER_STATUS_INACTIVE: "INACTIVE",
  USER_STATUS_TRIAL: "TRIAL",
  USER_STATUS_TRIAL_ENDED: "TRIAL_ENDED",

  VALUE_THIS: "-this-",
  VALUE_EMPTY: "",

  VIDEO_PLAYER_URL_YOUTUBE: "//www.youtube.com/embed/",
  VIDEO_PLAYER_URL_VIMEO: "//player.vimeo.com/video/",

  VIDEO_TYPE_ASSET: "asset",
  VIDEO_TYPE_VIMEO: "vimeo",
  VIDEO_TYPE_YOUTUBE: "youtube",

  LOTTIE_TYPE_ASSET: "asset",
  LOTTIE_TYPE_ASSET_LINK: "assetLink",

  VISIBLE_ALL: "a",
  VISIBLE_DESKTOP: "d",
  VISIBLE_MOBILE: "m",
  VISIBLE_NONE: "n",

  WP_BLOCK_POST: "post",
  WP_BLOCK_NEXT_POST: "next_post",
  WP_BLOCK_POSTS_VIEW_LOOKUP: "posts_lookup",
  WP_ELEMENT_FEATURED_IMAGE: "featured_image",
  WP_ELEMENT_TEXT: "text",
  WP_CAT: "cat",
  WP_TAG: "tag",
  WP_CPT_FILTER_TAXONOMY: "tax",
  WP_CPT_SLUG: "slug",
  WP_CPT_FILTERS: "filters",
  IS_CPT: "isCPT",
  CPT: "cpt",

  STANDARD_POST_TYPE: 0,
  CUSTOM_POST_TYPE: 1,

  WP_FIELD_POST_CONTENT: "post_content",

  WP_DEFAULT_POST_COUNT: 6,

  MAX_PAGES: 70,
  MAX_PAGE_WARNING_FREQUENCY: 5,
  MAX_PAGE_WARNING_COUNTER: "maxPageWarningCounter",

  MAX_PAGE_SIZE_BYTES: 1000000, // 1MB

  MAX_BLOCK_STATE_VIEWS: 50,

  MAX_GALLERY_IMAGES: 300,
  MAX_GALLERY_WARNING_FREQUENCY: 15,
  MAX_GALLERY_WARNING_COUNTER: "maxGalleryWarningCounter",

  UI_BUTTON_SIZE_SMALL: "sm",
  UI_BUTTON_SIZE_MEDIUM: "md",
  UI_BUTTON_ICON_SIZE_SMALL: "12",
  UI_BUTTON_ICON_SIZE_MEDIUM: "16",

  PAGE_PANEL_STATE_DEFAULT: "default",
  PAGE_PANEL_STATE_DISTANT: "distant",

  THEME_TYPE_BUTTONS: "buttons",
  BUTTON_PANEL_STATE_PRIMARY: "primary",
  BUTTON_PANEL_STATE_SECONDARY: "secondary",
  BUTTON_PANEL_TAB_STATE_REGULAR: "regular",
  BUTTON_PANEL_TAB_STATE_HOVER: "hover",
};

/**
 * Design Settings text styles, in display order.
 * @type {string[]}
 */
export const TEXT_STYLE_IDS = [
  AppConstants.TEXT_STYLE_TITLE,
  AppConstants.TEXT_STYLE_HEADING,
  AppConstants.TEXT_STYLE_SUBHEADING,
  AppConstants.TEXT_STYLE_PARAGRAPH,
];

export default AppConstants;
